import { render, staticRenderFns } from "./followupModal.vue?vue&type=template&id=f5b73424&scoped=true"
import script from "./followupModal.vue?vue&type=script&lang=js"
export * from "./followupModal.vue?vue&type=script&lang=js"
import style0 from "./followupModal.vue?vue&type=style&index=0&id=f5b73424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b73424",
  null
  
)

export default component.exports